var $ = require('jquery');
var _ = require('underscore');
var Marionette = require('backbone.marionette');
var d3 = require('d3');
var template = require('./template.hbs');
var ChartView = require('../../common/chart-view.js');
var Collection = require('../collection');

var Radio = require('backbone.radio');
var toolChannel = Radio.channel('tool');
var routerChannel = Radio.channel('router');

module.exports = ChartView.extend({
	template: template,
	className: 'map',
	active: d3.select(null),
	specs: {},
	colors: {
		selectedPath: '',
		hoverPath: '',
		pins: '#FF6E1B',
		pinsZoomed: '#fff',
		pinsZoomedStroke: '#555',
		pinsCampus: '#1295D8'
	},
	extra_data: {},
	// lon/lat offsets [lat-offset,lon-offset, end (1) or start (0) anchor ]
	campus_label_offsets: {
		'Davis': [4,0,1],
		'Berkeley': [2.5,0,1],
		'SF': [-1,0,0],
		'Merced': [4,0,1],
		'Santa Cruz': [-2.3,0,0],
		'Santa Barbara': [-3.5,0,0],
		'LA': [-3,0,0],
		'Riverside': [3,0,1],
		'San Diego': [-2.3,0,0],
		'Irvine': [-2.3,0,0],
	},

	constructor: function(options){
		ChartView.apply(this, arguments);
		this.createTooltip();
		this.registerEvents();
		this.load_extra_data();

		return this;
	},

	registerEvents: function(){
		var chart = this;

		toolChannel.on('map:ready', this.setDatum, chart);
		routerChannel.on('map:selectReset', this.selectReset, chart);

		this.listenTo( UCS.App.MapState,'change:type', this.updateBoundary, chart);
		this.listenTo( UCS.App.MapState,'change:id', this.setDatum, chart);
		this.listenTo( UCS.App.MapState,'change:zoomed', this.resetCheck, chart);
		this.listenTo( UCS.App.MapState,'change:selection', this.updateActive, chart);
	},



	updateBoundary: function(){
		UCS.App.MapState.set('zoomed', false);
		this.setPageTitle();
		var d;

		d = this.setDatum();

		this.onRender();
	},

	setDatum: function(){
		var type = UCS.App.MapState.get('type');
		var id = UCS.App.MapState.get('id');
		var d;


		if(type === 'county'){
			if(id){
				d = d3.select("#district_" + id).datum();
				UCS.App.MapState.set('datum',d);
			}else{
				UCS.App.MapState.set('datum',{});
			}
		}else{
			if(id){
				d = d3.select("#district_" + id).datum();
				UCS.App.MapState.set('datum',d);
			}else{
				UCS.App.MapState.set('datum',{});
			}
		}


		// else{
		// 	d = d3.select(null).datum();
		// 	UCS.App.MapState.set('datum',d);
		// }

		return d;
	},

	setDatum_hover: function(d){
		UCS.App.MapState.set('datum_hover',d);
	},

	toTitleCase: function(str) {
		str = str.replace(/_/gi, ' ');
	  return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
	},

	setPageTitle: function(){
		var type = UCS.App.MapState.get('type');
		var id = UCS.App.MapState.get('id');
		if( id == 0){ id = ''; };
		document.title = "UC Startups - Map - "  + this.toTitleCase(type) + " " + id;
	},

	updateActive: function(){
		var type = UCS.App.MapState.get('type');
		var selection = UCS.App.MapState.get('selection');
		var clickedElementID = '';



		if(type === 'county'){
			clickedElementID = '#district_'+selection.county_link;
		}else{
			clickedElementID = '#district_'+selection.district_number;
		}
		var clickedElement = d3.select(clickedElementID);

		this.setPageTitle();
		var d;

		d = this.setDatum();

		if(d){
			this.selectArea(d, clickedElement);
		}else{
			// console.info('No datum selected in updateActive');
			// put up a Intro block here.
		}

	},

	selectArea: function(d, clickedElement){
		var type = UCS.App.MapState.get('type');
		var id = UCS.App.MapState.get('id');
		var chart = this;

		var path = chart.specs.path,
				width = chart.dimensions.width,
				height = chart.dimensions.height,
				mapPathsGroup = chart.svg.select('.map-paths'),
				mapPinsGroup = chart.svg.select('.map-pins')
				specs = chart.specs;

		if (chart.active.node() === clickedElement.node() ){
			return this.selectReset();
		}else{
			UCS.App.MapState.set('zoomed', true);
			// Clear existing .active item
			chart.active.classed("active", false); // clear all active classes
			// Select new active item
			chart.active = clickedElement.classed("active", true); // clicked item will be classed active

			// Zoom to bounding box, click again to reset (calls selectReset)
			var bounds = path.bounds(d),
		      dx = bounds[1][0] - bounds[0][0],
		      dy = bounds[1][1] - bounds[0][1],
		      x = (bounds[0][0] + bounds[1][0]) / 2,
		      y = (bounds[0][1] + bounds[1][1]) / 2,
		      scale = 0.9 / Math.max(dx / width, dy / height),
		      translate = [width / 2 - scale * x, height * 9/16 - scale * y];

		  mapPathsGroup.transition()
	      .duration(750)
	      .style("stroke-width", 1 / scale + "px")
	      .attr("transform", "translate(" + translate + ")scale(" + scale + ")");

			mapPinsGroup.transition()
				.duration(750)
				.style("stroke-width", 1 / scale + "px")
				.attr("transform", "translate(" + translate + ")scale(" + scale + ")");

			mapPinsGroup.selectAll('.pin').transition()
				.duration(750)
				.attr("r", 5/scale)
				.style({
					fill: chart.colors.pinsZoomed,
					'fill-opacity': 0.75,
					'stroke-width':1/scale,
					'stroke-opacity': 0.25,
					'stroke': chart.colors.pinsZoomedStroke
				});

			mapPinsGroup.selectAll('.pin-campus').transition()
				.duration(750)
				.attr("r", 5/scale)
				.style({
					fill: chart.colors.pinsCampus,
					'stroke-width':2/scale,
					stroke: 'white'
				});

			mapPinsGroup.selectAll('.pin-campus-label')
				// .transition()
				// .duration(750)
				.attr({
					x: 0,
					y: 0,
					dx: '0.5em',
					dy: '0.35em',
					class: 'pin-campus-label',
					'text-anchor': 'start'
				})
				.style({
					"font-size": (1/scale)+"em",
					"font-weight": "bold"
				})
				.attr("transform", function(d) {
					var lat = Number(d.Latitude);
					var long = Number(d.Longitude);
					return "translate(" + specs.projection([
						long,
						lat
					]) + ")";
				});

			mapPinsGroup.selectAll('.pin-campus-label-line')
				.style("opacity","0");

			mapPinsGroup.selectAll('.pin-city-label')
				.attr({
					x: 0,
					y: 0,
					dx: '0.5em',
					dy: '0.35em',
				})
				.style({
					"font-size": (0.75/scale)+"em",
					"font-weight": "normal",
					"visibility": "visible"
				});

			mapPinsGroup.selectAll('.pin-city')
				.attr("r", 2/scale)
				.style("visibility","visible");
		}
	},

	resetCheck: function(){
		if( UCS.App.MapState.get('zoomed') === false ){
			this.selectReset();
		}
	},

	selectReset: function(){
		UCS.App.MapState.set('zoomed', false);
		var type = UCS.App.MapState.get('type');
		var chart = this,
			mapPathsGroup = chart.svg.select('.map-paths'),
			mapPinsGroup = chart.svg.select('.map-pins');

		var campus_label_offsets = chart.campus_label_offsets;



		// Clear all map paths with class active
	  chart.active.classed("active", false);
	  chart.active = d3.select(null);


		// Reset the Zoom
	  mapPathsGroup.transition()
      .duration(750)
      .style("stroke-width", "1px")
      .attr("transform", "translate(" + chart.options.margin.left + ", "+ chart.options.margin.top +")");

		mapPinsGroup.transition()
      .duration(750)
      .style("stroke-width", "1px")
      .attr("transform", "translate(" + chart.options.margin.left + ", "+ chart.options.margin.top +")");

		mapPinsGroup.selectAll('.pin').transition()
			.duration(750)
			.attr("r", 3)
			.style({
				'fill': chart.colors.pins,
				'fill-opacity': 0.5,
				'stroke-width': 0
			});

		mapPinsGroup.selectAll('.pin-campus').transition()
			.duration(750)
			.attr("r", 5)
			.style({
				'fill': chart.colors.pinsCampus,
				'stroke-width': 1,
				stroke: 'white'
			});

		mapPinsGroup.selectAll('.pin-campus-label')
			.attr({
				"class": "pin-campus-label unzoomed",
				dy: "-0.2em",
				dx: "0"
			})
			.attr('text-anchor', function(d){
				var name = d["Campus Name"];
				return campus_label_offsets[name][2] ? "end":"start";
			})
			.attr("transform", function(d) {
				var lat = Number(d.Latitude);
				var long = Number(d.Longitude);

					var name = d["Campus Name"];
					var long_offset = campus_label_offsets[name][0];
					var lat_offset = campus_label_offsets[name][1];

				return "translate(" + specs.projection([
					long + long_offset,
					lat + lat_offset
				]) + ")";
			})
			.style("font-size","0.75em");

		mapPinsGroup.selectAll('.pin-campus-label-line')
			.style("opacity","1");

		mapPinsGroup.selectAll('.pin-city-label')
			.style("visibility","hidden");

		mapPinsGroup.selectAll('.pin-city')
			.style("visibility","hidden");

		UCS.App.Router.navigate('map/' + type, {
			trigger: true, // call the route function
			replace: false // prevent browser history entry
		});
		this.setPageTitle();
	},

	// Workaround: for chart-wrapper not working on ChartView initialize
	onAttach: function(){
		this.$el.wrap($('<div class="chart-wrapper">'));
		this.onRender();
	},

	// override default onRender function
	onRender: function(){
		// Workaround: re-define these two after re-adding the chart-wrapper since it didn't quite get it on ChartView init
		this.$chart_container = this.$el.parent();
		this.chart_container = this.$chart_container.get(0);

		this.$el.empty();
		this.get_dimensions();
		this.create_svg();
		this.draw();

		return this;
	},

	create_svg: function() {
		var chart = this;

		// trying out animations
		// console.log('this dollar sign',this.$el.parent());
		// this.$el.parent().fadeIn();

    chart.svg = d3.select(chart.el).append("svg")
      .attr("width", chart.dimensions.wrapperWidth)
      .attr("height", $( window ).height())
      .attr("class", "chart");

		chart.svg.append("g")
			.classed('map-paths',true)
      .attr("transform", "translate(" + chart.options.margin.left + ", "+ chart.options.margin.top +")")
			.style({ 'stroke': 'white', 'stroke-width': 1 });

		chart.svg.append("g")
			.classed('map-pins',true)
			.attr("transform", "translate(" + chart.options.margin.left + ", "+ chart.options.margin.top +")")
			.style({
				fill: chart.colors.pins
			});

		chart.svg.append("g")
			.classed('legend',true);
	},

	draw: function(){
		var shapedata_path = UCS.App.MapState.get('path');

		this.load_shapedata(shapedata_path);

		return this;
	},

	load_shapedata: function(shapepath) {
		d3.json(shapepath, $.proxy(this.bind_data, this) );
	},

	load_extra_data: function(){
		var chart = this;
		d3.csv(this.options.campus_data_path, function(data){
			chart.extra_data.campus = data;
		});
		d3.csv(this.options.cities_data_path, function(data){
			chart.extra_data.cities = data;
		});
	},

	bind_data: function(error, json) {
		var type = UCS.App.MapState.get('type');
		var densityGroup = {
			'state_assembly': this.collection.state_assembly_districts_density,
			'state_senate': this.collection.state_senate_districts_density,
			'congressional':	this.collection.congressional_districts_density,
			'county':	this.collection.county_districts_density
		};
		var density = densityGroup[type];

		if(error){
			console.log(error);
		} else {
			if(type === 'county'){
				for (var i = 0; i < json.features.length; i++) {
					var division = json.features[i].properties.name.toLowerCase().replace(/ /gi, "-");
					json.features[i].properties.density = density[division];
				}

			}else{
				for (var i = 0; i < json.features.length; i++) {
					var division = parseInt(json.features[i].properties.name);
					json.features[i].properties.density = density[division];
				}
			}


			this.get_specifics(json);
		}
	},

	// Get specifics to this particular map chart type
	get_specifics: function(json){
		var chart = this;
		var specs = this.specs;
		// var projection = chart.specs.projection;


		// Set Scale, Center, Offset
		// chart.dimensions.scale = chart.options.scale; // Already determined in ChartView get_dimensions
		chart.dimensions.center = d3.geo.centroid(json);
		chart.dimensions.offset = [chart.dimensions.width/2, chart.dimensions.height * 9/16];

		// Define map projection
		specs.projection = d3.geo.mercator()
			.scale(chart.dimensions.scale)
			.translate(chart.dimensions.offset)
			.center(chart.dimensions.center);

		// Define path generator
		specs.path = d3.geo.path().projection(specs.projection);

		// Color Scale
		specs.color = d3.scale
			.quantize()
			//.range(['#eff3ff','#c6dbef','#9ecae1','#6baed6','#3182bd','#08519c']);
			.range(["rgb(217,230,236)", "rgb(153,187,205)", "rgb(51,118,154)", "rgb(0,85,129)"]);
			//.range(["red","orange","green","blue"]);

		specs.color.domain([
			d3.min(json.features, function (d) { return d.properties.density; }),
			d3.max(json.features, function (d) { return d.properties.density; })
		]);

		specs.color.domainArr = [
			d3.min(json.features, function (d) { return d.properties.density; }),
			d3.max(json.features, function (d) { return d.properties.density; })
		];

		this.draw_map(json);
	},

	draw_map: function(json){
		var type = UCS.App.MapState.get('type');
		var id = UCS.App.MapState.get('id');

		var chart = this;
		var path = chart.specs.path;
		var color = chart.specs.color;

		var mapPathsGroup = this.svg.select('.map-paths');

		mapPathsGroup.selectAll("path")
			.data(json.features)
			.enter()
			.append("path")
			// .transition() // Animation!
			// .duration(500)
			// .delay( function(d,i) { return i*50; } ) // This drastically improves transition performance when you have a ton of elements
			.attr("d", path)
			.attr("id", function(d){
				if(type === 'county'){
					return "district_" + d.properties.name.toLowerCase().replace(/ /gi, "-");
				}else{
					return "district_"+parseInt(d.properties.external_id,10);
				}

			})
			.attr("class", function(d){

				if( parseInt(d.properties.external_id,10) === id ){
					return "active";
				}else{
					return "";
				}

			})
			.classed("filled", function(d){
				return d.properties.density;
			})
			.style("fill", function(d) {
				//Get data value
				var value = d.properties.density;
				if (value) {
					//If value exists…
					return color(value);
				} else {
					//If value is undefined…
					return "#efefef";
				}
			});


		this.drawPins();
		this.draw_legend();
		this.bind_mouse_events();
		chart.active = d3.select('#map_1_svg svg.chart g.map-paths .active');


	},

  createTooltip: function() {
    var chart = this;

		var tooltip_fields = {
			1: ['h3', 'title'],
			2: ['p', 'total_revenue'],
			3: ['p', 'employees'],
			4: ['p', 'startups']
		};

		// let's only add one #tooltip
		if( !$('#tooltip').length ){
			chart.tooltip = d3.select("body")
	      .append("div")
	        .attr("id", "tooltip")
					.attr("class","tooltip")
	        .style("position", "absolute")
	        .style("z-index", "10")
	        .style("visibility", "hidden");
		}else {
			$('#tooltip').empty();
			chart.tooltip = d3.select("#tooltip");
		}

		_.each(tooltip_fields, function(element, index, list){

			var tooltip = d3.select("#tooltip");

			tooltip.append(element[0])
				.attr("class", element[1]);

			tooltip.select("."+element[1])
				.insert("span")
				.attr("class", "label");

			tooltip.select("."+element[1])
				.insert("span")
				.attr("class", "value");
		});
  },

	bind_mouse_events: function() {
    var chart = this;

		var lacksTouchEvents = $('html').hasClass('no-touchevents');
		if(lacksTouchEvents){
			chart.svg.selectAll("path")
	      .on("mouseover", function(d) {
					UCS.App.MapState.set('datum_hover',d);
					var tooltip = UCS.App.MapState.get('hover');

					if( tooltip.num_startups == 0){
						return chart.tooltip.style("visibility", "hidden");
					}

					// Update tooltip text
					if(tooltip.boundary_kind === 'County'){
						d3.select("#tooltip")
		          .select("h3.title")
		          .text(tooltip.district_name + " " + tooltip.boundary_kind);
					}else {
						d3.select("#tooltip")
		          .select("h3.title")
		          .text(tooltip.boundary_kind  + " " +  tooltip.district_number);
					}

					d3.select("#tooltip .total_revenue .label")
		        .text('Total Revenue ');
					d3.select("#tooltip .total_revenue .value")
		        .text(tooltip.total_revenue);

					d3.select("#tooltip .employees .label")
			      .text('Jobs ');
					d3.select("#tooltip .employees .value")
			      .text(tooltip.num_employees);

					d3.select("#tooltip .startups .label")
		        .text('Startups ');
					d3.select("#tooltip .startups .value")
		        .text(tooltip.num_startups);

	        // d3.select("#tooltip .population")
	        //   .text('Population: ' + tooltip.population);

	        return chart.tooltip.style("visibility", "visible");
	      })
	      .on("mousemove", function() {
	        var svg_width = d3.select(chart.el)[0][0].clientWidth;
	        var tip_width = $(chart.tooltip[0][0]).width();

	        //set position of the tooltip based on mouse position
	        if (d3.event.offsetX > ((svg_width - tip_width - 20))) {
	          return chart.tooltip
	            .style("top", (d3.event.pageY-10)+"px")
	            .style("left",(d3.event.pageX-(tip_width+32))+"px");
	        } else {
	          return chart.tooltip
	            .style("top", (d3.event.pageY-10)+"px")
	            .style("left",(d3.event.pageX+10)+"px");
	        }
	      })
	      .on("mouseout", function(){
	        return chart.tooltip.style("visibility", "hidden");
	      });
		}

		chart.svg.selectAll("path")
			.on("click", function(d){
				var tooltip = UCS.App.MapState.get('hover');
				if( tooltip.num_startups == 0){
					return;
				}

				var type = UCS.App.MapState.get('type');
				var isMatch;

				if(type === 'county'){
					var id = d.properties.metadata.Name.toLowerCase().replace(/ /gi, "-");
					isMatch = (id === UCS.App.MapState.get('selection').county_link);
				}else {
					var id = parseInt(d.properties.metadata.DISTRICT,10);
					isMatch = (id === UCS.App.MapState.get('selection').district_number);
				}

				if(isMatch && chart.active[0][0]){
					chart.updateActive();
					return;
				}

				var navis = UCS.App.MapState.get('navi');
				UCS.App.MapState.set({ navi: navis + 1 });

				UCS.App.Router.navigate('map/' + type + '/' + id, {
					trigger: true, // call the route function
					replace: false // prevent browser history entry
				});
			});

			toolChannel.trigger('map:ready');
  },

	drawPins: function(){
		var chart = this;
		var specs = this.specs;
		var coll = chart.collection.onlyActive();
		var onlyActiveArr = coll.toJSON();



		var mapPinsGroup = chart.svg.select('.map-pins');

    mapPinsGroup.selectAll(".pin")
		  .data(onlyActiveArr)
		  .enter()
			.append("circle")
			.attr('class','pin')
		  .attr("r", 3)
			// .transition() // Animation!
			// .duration(500)
  		// .delay( function(d,i) { return i*50; } ) // This drastically improves transition performance when you have a ton of elements
		  .attr("transform", function(d) {
		    return "translate(" + specs.projection([
		      d.longitude,
		      d.latitude
		    ]) + ")";
		  })
			.attr('style','pointer-events: none')
			.style({
				'fill': chart.colors.pins,
				'fill-opacity': 0.5,
				'stroke-width': 0
			});

		this.draw_city_points();
		this.draw_campus_points();
	},
	draw_campus_points: function(){
		var chart = this;
		var specs = this.specs;
		var data = chart.extra_data.campus;



		var mapPinsGroup = chart.svg.select('.map-pins');
		var campus_label_offsets = chart.campus_label_offsets;

		var node = mapPinsGroup.selectAll(".pin-campus")
			.data(data)
			.enter();



		node
			.append("text")
				.attr({
					x: 0,
					y: 0,
					dy: '-0.2em',
					dx: '0',
					'text-anchor': 'start',
					class: 'pin-campus-label unzoomed',
					'font-size': '0.75em'
				})
				.attr('text-anchor', function(d){
					var name = d["Campus Name"];
					return campus_label_offsets[name][2] ? "end":"start";
				})
				.attr("transform", function(d) {
					var lat = Number(d.Latitude);
					var long = Number(d.Longitude);

						var name = d["Campus Name"];
						var long_offset = campus_label_offsets[name][0];
						var lat_offset = campus_label_offsets[name][1];

					return "translate(" + specs.projection([
						long + long_offset,
						lat + lat_offset
					]) + ")";
				})
				.text(function(d){
					if(d["Campus Name"] === "LA" || d["Campus Name"] === "SF"){
						return "UC" + d["Campus Name"];
					}else{
						return "UC " + d["Campus Name"];
					}
				});

		node.append("line")
			.attr("class","pin-campus-label-line")
			.attr("x1", function(d){
				var lat = Number(d.Latitude);
				var long = Number(d.Longitude);
				var origin = specs.projection([long,lat]);

				return origin[0];
			})
			.attr("y1", function(d){
				var lat = Number(d.Latitude);
				var long = Number(d.Longitude);
				var origin = specs.projection([long,lat]);

				return origin[1];
			})
			.attr("x2", function(d){
				var lat = Number(d.Latitude);
				var long = Number(d.Longitude);

				var name = d["Campus Name"];
				var offset = campus_label_offsets[name][0];

				var target = specs.projection([long + offset,lat]);
				return target[0];
			})
			.attr("y2", function(d){
				var lat = Number(d.Latitude);
				var long = Number(d.Longitude);
				var target = specs.projection([long,lat]);

				return target[1];
			})
			;

		node
			.append("circle")
			.attr('class','pin-campus')
			.attr("r", 5)
			.attr("transform", function(d) {
				var lat = Number(d.Latitude);
				var long = Number(d.Longitude);
				return "translate(" + specs.projection([
					long,
					lat
				]) + ")";
			})
			.attr('style','pointer-events: none')
			.style({
				'fill': chart.colors.pinsCampus,
				'stroke-width': 1,
				stroke: 'white'
			});
	},

	draw_city_points: function(){
		var chart = this;
		var specs = this.specs;
		var data = chart.extra_data.cities;

		var mapPinsGroup = chart.svg.select('.map-pins');

		var node = mapPinsGroup.selectAll(".pin-city")
			.data(data)
			.enter();

		node
			.append("text")
				.attr({
					x: 0,
					y: 0,
					dy: '-0.2em',
					dx: '0',
					'text-anchor': 'start',
					class: 'pin-city-label unzoomed',
					'font-size': '0.75em'
				})
				.attr("transform", function(d) {
					var lat = Number(d.Latitude);
					var long = Number(d.Longitude);
					return "translate(" + specs.projection([
						long,
						lat
					]) + ")";
				})
				.text(function(d){
					return d.Name;
				})
				.style({
					visibility: 'hidden'
				});

		node
			.append("circle")
			.attr('class','pin-city')
			.attr("r", 2)
			.attr("transform", function(d) {
				var lat = Number(d.Latitude);
				var long = Number(d.Longitude);
				return "translate(" + specs.projection([
					long,
					lat
				]) + ")";
			})
			.attr('style','pointer-events: none')
			.style({
				'fill': 'gray',
				visibility: 'hidden'
			});
	},

	draw_legend: function(){
		// via http://bl.ocks.org/KoGor/5685876
		var chart = this;
		var specs = this.specs;
		var svg = chart.svg;
		var width = chart.dimensions.width,
				height = chart.dimensions.height;
		var domainArr = specs.color.domainArr;
		var legendArr = processDomainArr(domainArr);
		var ls_w = 15, ls_h = 15; // legend color swatch dimensions

		$('#map_1_svg svg .legend').empty(); // clear out

		var legend_group = chart.svg.select('g.legend');

		var legend_node = legend_group.selectAll("g.legend-node")
			.data(legendArr)
			.enter().append("g")
			.attr("class", "legend-node");

		legend_group.append("text")
			.attr("x", 20)
			.attr("y", function(){ return height - 90})
			.text('Startups')
			.attr("class","title");

		legend_node.append("rect")
			.attr("x", 20)
			.attr("y", function(d, i){ return height - (i*ls_h) - 2*ls_h;})
			.attr("width", ls_w)
			.attr("height", ls_h)
			.attr("stroke","white")
			.attr("stroke-width",1)
			.style("fill", function(d, i) { return specs.color(d); });

		var legend_labels = formatLabel(legendArr);

		legend_node.append("text")
			.attr("x", 40)
			.attr("y", function(d, i){ return height - (i*ls_h) - ls_h - 4;})
			.text(function(d, i){ return legend_labels[i]; });

		function processDomainArr(array){
			for(var i=0; i < 3; i++){
				var point = (array[0] + array[array.length-1])* (0.25 * (i+1)) +1;
				array.splice(1, 0, point);
			}
			array.sort(function(a, b) {
				return a - b;
			});
			array.pop();
			return array;
		}

		function formatLabel(array){
			for(var j=0; j < array.length; j++){
				if(j === 0){
					array[j] = "> 0";
				}else {
					array[j] = (array[j] - 1) + "+";
				}
			}
			return array;
		}
	},

	get_dimensions: function() {
		// Overriding to support height-based breakpoints

		// For some reason, if I declare custom breakpoints at MapView construction (say, in tools/layout-view.js),
		// they don't get made into an Array of breakpoints ( _.every needs this, below)

		// If the breakpoints aren't an array, make them an array!
		if( !Array.isArray(this.options.breakpoints) ){
			this.options.breakpoints = this.setUpBreakpoints(this.options.breakpoints);
		}

    var window_width = $(window).width();
		var window_height = $(window).height()

    var wrapperWidth = this.$chart_container.width();
    var width = wrapperWidth - this.options.margin.left - this.options.margin.right;
    var height = this.options.base_height - this.options.margin.bottom - this.options.margin.top;
		var scale = this.options.base_scale;

		if(window_height < 400 && window_width > 768 ){
			scale = 1000;
			height = 300;
			wrapperHeight = 300;
		}else if(window_height < 700 && window_width > 768){
			scale = 2000;
			height = 550;
			wrapperHeight = 525;
		}else {
	    _.every(this.options.breakpoints, _.bind(function(breakpoint) {
	      var width = breakpoint[0];
	      if (window_width <= width) {
	        var multiplier = breakpoint[1];
	        height = (height - this.options.margin.bottom - this.options.margin.top) * multiplier;
					scale = scale * multiplier;
	        return false;
	      }
	      return true;
	    }, this));

	    var wrapperHeight = height + this.options.margin.top + this.options.margin.bottom;
		}
    //console.log('VIEW OPTIONS', this.options);
    this.$el.height(wrapperHeight);

    this.dimensions = {
      width: width,
      height: height,
      wrapperWidth: wrapperWidth,
      wrapperHeight: wrapperHeight,
			scale: scale
    };
  }


});
